import { locale as english } from './en';
// import { locale as turkish } from './tr';
import { locale as spanish } from './es';
// import { locale as zh1 } from './zh1';
// import { locale as zh2 } from './zh2';

export const lang_eschedule_izzi = [english, spanish];
// export const lang_perfiles = [english, turkish, spanish, zh1, zh2];
